import { Home } from 'src/presentation/pages'

export const makeHome = () => <Home />
